// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer__container {
  background-color: var(--black-color);
}

.footer__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid var(--accent-color);
}

.footer__body {
  display: grid;
}
.footer__body button {
  padding: 0;
}

.footer__text {
  color: var(--secondary-text-color);
  font-weight: 500;
  line-height: 140%;
  text-transform: uppercase;
}

@media only screen and (min-device-width: 320px) {
  .footer__content {
    padding: 24px 5% 32px 5%;
  }
  .footer__header {
    gap: 36px;
    align-items: flex-start;
    flex-direction: column;
    padding-bottom: 36px;
  }
  .footer__body {
    padding-top: 36px;
    gap: 36px 120px;
    justify-items: start;
    grid-template-columns: min-content;
    grid-template-rows: repeat(5, min-content);
  }
  .footer__text {
    padding-top: 52px;
    font-size: 18px;
    letter-spacing: 0.54px;
  }
}
@media only screen and (min-device-width: 768px) {
  .footer__content {
    padding: 60px 9.4% 80px 9.4%;
  }
  .footer__header {
    gap: 36px;
    align-items: flex-start;
    flex-direction: column;
    padding-bottom: 36px;
  }
  .footer__body {
    padding-top: 36px;
    gap: 36px 120px;
    justify-items: start;
    grid-template-columns: min-content min-content min-content;
    grid-template-rows: min-content min-content;
  }
  .footer__text {
    padding-top: 52px;
    font-size: 18px;
    letter-spacing: 0.54px;
  }
}
@media only screen and (min-device-width: 992px) {
  .footer__content {
    padding: 80px 9.4% 100px 9.4%;
  }
  .footer__header {
    flex-direction: row;
    align-items: center;
    padding-bottom: 36px;
  }
  .footer__body {
    padding-top: 36px;
    gap: 36px 120px;
    justify-items: start;
    grid-template-columns: min-content min-content min-content;
    grid-template-rows: min-content min-content;
  }
  .footer__text {
    padding-top: 52px;
    font-size: 18px;
    letter-spacing: 0.54px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .footer__content {
    padding: 80px 9.4% 100px 9.4%;
  }
  .footer__header {
    align-items: center;
    flex-direction: row;
    padding-bottom: 36px;
  }
  .footer__body {
    padding-top: 36px;
    gap: 36px 120px;
    justify-items: start;
    grid-template-columns: min-content min-content min-content;
    grid-template-rows: min-content min-content;
  }
  .footer__text {
    padding-top: 52px;
    font-size: 18px;
    letter-spacing: 0.54px;
  }
}
@media only screen and (min-device-width: 1920px) {
  .footer__content {
    padding: 80px 180px 100px 180px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/footer.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4CAAA;AACF;;AAEA;EACE,aAAA;AACF;AACE;EACE,UAAA;AACJ;;AAGA;EACE,kCAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAAF;;AAGA;EACE;IACE,wBAAA;EAAF;EAEA;IACE,SAAA;IACA,uBAAA;IACA,sBAAA;IACA,oBAAA;EAAF;EAEA;IACE,iBAAA;IACA,eAAA;IACA,oBAAA;IACA,kCAAA;IACA,0CAAA;EAAF;EAEA;IACE,iBAAA;IACA,eAAA;IACA,sBAAA;EAAF;AACF;AAGA;EACE;IACE,4BAAA;EADF;EAGA;IACE,SAAA;IACA,uBAAA;IACA,sBAAA;IACA,oBAAA;EADF;EAGA;IACE,iBAAA;IACA,eAAA;IACA,oBAAA;IACA,0DAAA;IACA,2CAAA;EADF;EAGA;IACE,iBAAA;IACA,eAAA;IACA,sBAAA;EADF;AACF;AAIA;EACE;IACE,6BAAA;EAFF;EAIA;IACE,mBAAA;IACA,mBAAA;IACA,oBAAA;EAFF;EAIA;IACE,iBAAA;IACA,eAAA;IACA,oBAAA;IACA,0DAAA;IACA,2CAAA;EAFF;EAIA;IACE,iBAAA;IACA,eAAA;IACA,sBAAA;EAFF;AACF;AAKA;EACE;IACE,6BAAA;EAHF;EAKA;IACE,mBAAA;IACA,mBAAA;IACA,oBAAA;EAHF;EAKA;IACE,iBAAA;IACA,eAAA;IACA,oBAAA;IACA,0DAAA;IACA,2CAAA;EAHF;EAKA;IACE,iBAAA;IACA,eAAA;IACA,sBAAA;EAHF;AACF;AAMA;EACE;IACE,+BAAA;EAJF;AACF","sourcesContent":[".footer__container {\n  background-color: var(--black-color);\n}\n\n.footer__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2px solid var(--accent-color);\n}\n\n.footer__body {\n  display: grid;\n\n  button {\n    padding: 0;\n  }\n}\n\n.footer__text {\n  color: var(--secondary-text-color);\n  font-weight: 500;\n  line-height: 140%;\n  text-transform: uppercase\n}\n\n@media only screen and (min-device-width: 320px) {\n  .footer__content {\n    padding: 24px 5% 32px 5%;\n  }\n  .footer__header {\n    gap: 36px;\n    align-items: flex-start;\n    flex-direction: column;\n    padding-bottom: 36px;\n  }\n  .footer__body {\n    padding-top: 36px;\n    gap: 36px 120px;\n    justify-items: start;\n    grid-template-columns: min-content;\n    grid-template-rows: repeat(5, min-content);\n  }\n  .footer__text {\n    padding-top: 52px;\n    font-size: 18px;\n    letter-spacing: 0.54px;\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .footer__content {\n    padding: 60px 9.4% 80px 9.4%;\n  }\n  .footer__header {\n    gap: 36px;\n    align-items: flex-start;\n    flex-direction: column;\n    padding-bottom: 36px;\n  }\n  .footer__body {\n    padding-top: 36px;\n    gap: 36px 120px;\n    justify-items: start;\n    grid-template-columns: min-content min-content min-content;\n    grid-template-rows: min-content min-content;\n  }\n  .footer__text {\n    padding-top: 52px;\n    font-size: 18px;\n    letter-spacing: 0.54px;\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  .footer__content {\n    padding: 80px 9.4% 100px 9.4%;\n  }\n  .footer__header {\n    flex-direction: row;\n    align-items: center;\n    padding-bottom: 36px;\n  }\n  .footer__body {\n    padding-top: 36px;\n    gap: 36px 120px;\n    justify-items: start;\n    grid-template-columns: min-content min-content min-content;\n    grid-template-rows: min-content min-content;\n  }\n  .footer__text {\n    padding-top: 52px;\n    font-size: 18px;\n    letter-spacing: 0.54px;\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .footer__content {\n    padding: 80px 9.4% 100px 9.4%;\n  }\n  .footer__header {\n    align-items: center;\n    flex-direction: row;\n    padding-bottom: 36px;\n  }\n  .footer__body {\n    padding-top: 36px;\n    gap: 36px 120px;\n    justify-items: start;\n    grid-template-columns: min-content min-content min-content;\n    grid-template-rows: min-content min-content;\n  }\n  .footer__text {\n    padding-top: 52px;\n    font-size: 18px;\n    letter-spacing: 0.54px;\n  }\n}\n\n@media only screen and (min-device-width: 1920px) {\n  .footer__content {\n    padding: 80px 180px 100px 180px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
